import LogRocket from 'logrocket';

if (process.env.REACT_APP_NODE_ENV !== "local") {
  LogRocket.init('xnfxye/nangita');
}
